export default {
  idRolExACHS: 8,
  idRolAutoasignacion: 72,

  idGrupoSuperUsuario: 'Portal_super_usuario',

  idTabAchsVirtual: "ID_TAB_ACHS_VIRTUAL",
  idTabLGF: "ID_TAB_LFG",
  idTabPortalEmpresa: "ID_TAB_PORTA_EMPRESA",
  idTabAchsGestion: "ID_TAB_ACHS_GESTION",

  stateLoading: "loading",
  stateError: "error",
  stateSuccess: "success",

  codePerfilEmpresa: "PER_EMPRESA",
  codePerfilTrabajador: "PER_TRABAJADOR",
  codePerfilACHS: "PER_ACHS",

  codeRolDependiente: "PER_TRABAJADOR_ROL_DEPENDIENTE",
  codeRolTrabajadorAchs: "PER_ACHS_ROL_TRABAJADOR_ACHS",
  codeRolIndependiente: "PER_TRABAJADOR_ROL_INDEPENDIENTE",
  codeRolExACHS: "PER_TRABAJADOR_ROL_EX_ACHS",
  codeRolPortalEmpresa: "PER_POR_EXT_ROL_PORTAL_EMPRESA",
  codeRolACHSGestion: "PER_POR_EXT_ROL_ACHS_GESTION",
  codeRolLGF: "PER_POR_EXT_ROL_LGF",
  codeRolAutoasignacion: 'PER_ACHS_ROL_AUTOASIGNACION_ACHS',

  achsRut: "70360100-6",

  lunes: "lunes",
  martes: "martes",
  miercoles: "miércoles",
  jueves: "jueves",
  viernes: "viernes",
  sabado: "sábado",
  domingo: "domingo",

  roleTypes: [
    {
      Id: 1,
      Name: 'Empresa',
      Code: 'PER_EMPRESA'
    },
    {
      Id: 2,
      Name: 'Trabajador',
      Code: 'PER_TRABAJADOR'
    },
    // {
    //   Id:5,
    //   // Name:'SEL',
    //   Name:'Agendamiento SEL',
    //   Code:'PER_SEL'
    // }
  ],
  workerPermits: [
    {
      Id: 6,
      Name: 'Interno',
      Description: 'trabajador por el cual se paga cotizaciones'
    },
    {
      Id: 8,
      Name: 'Externo',
      Description: 'trabajador que presta servicios externos a la empresa, pero no se paga cotizaciones por este'
    },
  ]
};


export const roleTypes = [
      {
        Id:1,
        Name:'Empresa',
        Code:'PER_EMPRESA'
      },
      {
        Id:2,
        Name:'Trabajador',
        Code:'PER_TRABAJADOR'
      },
      {
        Id:5,
        Name:'Agendamiento SEL',
        Code:'PER_SEL'
      }
]

export const workerPermits = [
      {
        Id:6,
        Name: 'Interno',
        Description:'trabajador por el cual se paga cotizaciones'
      },
      {
        Id:8,
        Name: 'Externo',
        Description:'trabajador que presta servicios externos a la empresa, pero no se paga cotizaciones por este'
      },
]

